module.exports = __webpack_public_path__ + "img/wallet-three-big.fe32f2a7.svg";